import React from 'react';
import { IBasicIconProps } from '../IBasicIconProps';

const TrashIcon: React.FC<IBasicIconProps> = ({
	width = 13,
	height = 13,
	color = '#000000',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 23 23"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g
				transform="translate(-871.000000, -584.000000)"
				fill={color}
				fillRule="nonzero"
			>
				<g transform="translate(85.000000, 543.000000)">
					<g transform="translate(786.000000, 41.000000)">
						<path
							d="M16.944895,22.0416667 L5.27137558,22.0416667 C4.00757576,22.0416667 2.98489564,20.858286 2.98489564,19.395897 L2.98489564,4.41603012 C2.98489564,4.41603012 2.98489564,4.39678816 2.98489564,4.38716718 L0.582013077,4.38716718 C0.257748648,4.38716718 0,4.08891678 0,3.71369853 C0,3.33848029 0.257748648,3.04022989 0.582013077,3.04022989 L6.41877279,3.04022989 L6.41877279,2.23206751 C6.41877279,1.00058199 7.28347793,0 8.34773042,0 L13.5692192,0 C14.5420124,0 15.3235729,0.875509239 15.3485163,2.00116397 L15.3734597,3.04022989 L21.4596536,3.04022989 C21.783918,3.04022989 22.0416667,3.33848029 22.0416667,3.71369853 C22.0416667,4.08891678 21.783918,4.38716718 21.4596536,4.38716718 L19.2064315,4.38716718 C19.2064315,4.38716718 19.2064315,4.40640914 19.2064315,4.41603012 L19.2064315,19.4151389 C19.2064315,20.858286 18.1920659,22.0416667 16.9365805,22.0416667 L16.944895,22.0416667 Z M4.14892179,4.38716718 C4.14892179,4.38716718 4.14892179,4.40640914 4.14892179,4.41603012 L4.14892179,19.386276 C4.14892179,20.0982286 4.65610461,20.6851084 5.27137558,20.6851084 L16.944895,20.6851084 C17.5518515,20.6851084 18.0507199,20.1174705 18.0507199,19.405518 L18.0507199,4.41603012 C18.0507199,4.41603012 18.0507199,4.39678816 18.0507199,4.38716718 L4.14892179,4.38716718 Z M7.58279894,3.04022989 L14.2094335,3.04022989 L14.1844901,2.0396479 C14.1761757,1.65480867 13.9017981,1.34693729 13.5692192,1.34693729 L8.34773042,1.34693729 C7.92369232,1.34693729 7.58279894,1.7413975 7.58279894,2.23206751 L7.58279894,3.04022989 L7.58279894,3.04022989 Z M13.1119232,18.4337989 C12.7876587,18.4337989 12.5299101,18.1355485 12.5299101,17.7603303 L12.5299101,7.29270333 C12.5299101,6.91748509 12.7876587,6.61923469 13.1119232,6.61923469 C13.4361876,6.61923469 13.6939363,6.91748509 13.6939363,7.29270333 L13.6939363,17.7603303 C13.6939363,18.1355485 13.4361876,18.4337989 13.1119232,18.4337989 L13.1119232,18.4337989 Z M8.78008299,18.4337989 C8.45581856,18.4337989 8.19806991,18.1355485 8.19806991,17.7603303 L8.19806991,7.29270333 C8.19806991,6.91748509 8.45581856,6.61923469 8.78008299,6.61923469 C9.10434742,6.61923469 9.36209606,6.91748509 9.36209606,7.29270333 L9.36209606,17.7603303 C9.36209606,18.1355485 9.10434742,18.4337989 8.78008299,18.4337989 Z"
							id="Shape"
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default TrashIcon;
